/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHosportsSiteConfigData } from './hosports-site-config.data';
import { IHosportsSiteConfigProps } from './hosports-site-config.props.autogenerated';

export interface IHosportsSiteConfigViewProps extends IHosportsSiteConfigProps<IHosportsSiteConfigData> {}

/**
 *
 * HosportsSiteConfig component
 * @extends {React.PureComponent<IHosportsSiteConfigProps<IHosportsSiteConfigData>>}
 */
class HosportsSiteConfig extends React.PureComponent<IHosportsSiteConfigProps<IHosportsSiteConfigData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HosportsSiteConfig;
